import {__VOYAGER__} from './api-config';

export const defaultFlavour = 'v3';
export const defaultCurrency = 'INR';
export const defaultRoomString = '1-2-0'; // duplicate remove one.
export const DEFAULT_PAX_STRING = '1-2-0';
export const defaultSorting = 'popularity';
export const defaultLengthOfStay = 1;
export const olderRoomStringRegex = '/(d)-(d)_(d)/';
export const defaultPartner = 'hotels/v1';
export const defaultVertical = 'mypartner';
export const defaultCityVoyagerObjType = 'city';
export const srpIndexForFetchMore = 2;
export const rupeeString = '₹';
export const maxAllowedRoomNights = 20;

export const metaCookieName = 'fe_trfc_seg';
export const defaultCheckinTime = '12: 00';

// export const googleMapsApiKey = 'AIzaSyD9iq-4g7CePAx8L_w3biSfZCdtPTZh0kE'; // goibibo key
export const googleMapsApiKey = 'AIzaSyABd38KlHi4ubA7niCtno96N9MY7N3GrS8'; // goibibo key
export const descblockNewHotelsId = 'newhotels';
export const paymentApiFailureDefaultMessage = 'Something went wrong!';

export const descblockApiFailureDefaultMessage = 'Selected Room is not available. Please try some other option.';
export const reviewPagePricingAddOnListEarlyCheckInID = 'htl-addon_pah';
export const reviewPageGocashId = 'htl-gcp';
export const isPahReviewPageButtonText = 'Reserve Now Pay Later';
export const isPahCCReviewPageButtonText = 'Reserve Now';
export const isVerificationRequiredButtonText = 'Verify & Pay';

export const smartEngageBannerSlot = 3;
/* smartEngageBannerCount is 2 to acoomodate another banner at the top for offers
   Later adding slots will be made dynamic by reading slots specific info from voyager call itself
*/
export const smartEngageBannerCount = 2;

export const sortingKeyLabelMap = {
  popularity: 'Trending Hotels',
  priceup: 'Price (Low to High)',
  pricedown: 'Price (High to Low)',
  rating: 'Customer Ratings',
};

// no default country should be there
export const defaultCountry = 'india';
export const defaultDestination = {
  nh: 4551,
  s_sc: 10.365,
  xtr: {
    cc: 'IN',
    dv: 3229902,
    slot_book: 1
  },
  n: 'Goa',
  t: 'city',
  crd: [
    15.299,
    74.124
  ],
  _id: '8717279093827200968',
  ct: {
    _id: '8717279093827200968',
    n: 'Goa'
  }
};

// kept grouped because india should get changed for both, if changed
export const countryTextMap = {
  india: {key: 'india', value: 'India'},
  international: {key: 'international', value: 'International'},
};

export const amenitiesMapForSimilarHotels = {
  bc: 'Room Service',
  gym: 'Gym/Spa',
  int: 'Internet Access',
  rest: 'Restaurant',
  sp: 'Swimming Pool',
  freeint: 'Free Internet',
  ac: 'ac active',
  chk: 'chk active',
};

export const BASE_VOYAGER_SEARCH_URL = `${__VOYAGER__}/api/v1/hotels_search/find_node_by_name/`;

export const searchWidgetLocationSearchURL = (search_query: string, partner: string) => {
  const params = {
    search_query,
    limit: 10,
    qt: 'N',
    inc_ggl_res: true,
  };

  if (partner === 'gostays') {
    params.hlt = 'gostays';
  }

  const paramsStringified = JSON.stringify(params);

  return `${BASE_VOYAGER_SEARCH_URL}?params=${paramsStringified}`;
};

export const locationAndHotelSearchURL = ({
  inputValue,
  limit = 10,
  cityId,
}: {
  inputValue: string;
  limit?: number;
  cityId: number;
}) => {
  const params = JSON.stringify({
    search_query: inputValue,
    city_filter_id: cityId,
    limit,
    qt: 'D',
    inc_ggl_res: true,
    include_t: ['voy.area', 'voy.landmark', 'ggl.area', 'ggl.landmark', 'voy.hotel'],
  });
  return `${BASE_VOYAGER_SEARCH_URL}?&params=${params}`;
};
